import React from "react";
import { Box, Grid, Typography } from "@mui/material";
function NoWorkflowsPanel({
  onCreateWorkflow,
  imgUrl,
}: {
  onCreateWorkflow: () => void;
  imgUrl: string;
}) {
  return (
    <Box
      sx={(theme) => ({
        mt: 4,
        height: "60vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      })}
    >
      <Grid container spacing={4} alignItems="center">
        <Grid item xs={12} md={6}>
          <Typography color="grey.100" variant="h1" fontWeight="bold" mb={4}>
            Increase your sales and drive engagement via workflows!
          </Typography>
          <Typography color="grey.80" variant="h4R" mb={8}>
            Choose from our proven predefined workflows for increased sales or
            build a customized workflow from scratch to meet your specific
            requirements.
          </Typography>
        </Grid>
        <Grid item xs={12} md={6} sx={{ textAlign: "center" }}>
          <Box
            component="img"
            src={imgUrl}
            alt="Workflow diagram"
            sx={{
              maxWidth: "100%",
              height: "auto",
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default NoWorkflowsPanel;
